import React from 'react';
import ReactDOM from 'react-dom/client';
import 'antd/dist/reset.css'; // Import Ant Design reset styles
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios'; // Import axios
import './i18n'; // Import i18n configuration

// Set default base URL for Axios requests
// Use environment variable for production (e.g., Render), fallback to CLOUD backend for local development testing
const API_URL = process.env.REACT_APP_API_URL || 'https://care360-backend.onrender.com/api/v1'; // Point fallback to Render backend
axios.defaults.baseURL = API_URL;
console.log('API Base URL set to:', axios.defaults.baseURL); // For debugging

// Helper function to check if a request is for the patient portal
const isPortalRequest = (config) => {
  if (!config || !config.url) return false;

  // Check if URL contains portal paths
  const portalPaths = ['/portal/', '/api/v1/portal/', '/api/portal/'];
  // Check if the baseURL is the full portal URL, indicating a portal-specific request
  if (axios.defaults.baseURL.includes('/portal')) {
    return true;
  }
  return portalPaths.some(path => config.url.includes(path));
};

// Helper function to check if current page is patient portal
const isPortalPage = () => {
  return window.location.pathname.startsWith('/portal');
};

// Add a request interceptor to include the token in headers
axios.interceptors.request.use(
  config => {
    // Do not attach main auth token to portal requests, as they have their own auth
    if (isPortalRequest(config)) {
      return config;
    }

    // Get the token from localStorage (stored as 'authToken' by AuthContext)
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle 401 errors
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    // Handle 401 errors (unauthorized)
    if (error.response && error.response.status === 401) {
      // Don't handle 401s for portal requests, login requests, when on portal pages, or requests with bypass flag
      const isPortalReq = isPortalRequest(error.config);
      const isLoginReq = error.config.url.includes('/login');
      const isOnPortalPage = isPortalPage();
      const bypassInterceptor = error.config.bypassGlobalInterceptor;

      if (!isPortalReq && !isLoginReq && !isOnPortalPage && !bypassInterceptor) {
        console.warn('401 Unauthorized - clearing main app auth token');
        localStorage.removeItem('authToken');
        // Optionally redirect to login page
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
